import React, {useEffect, useState, memo, useCallback} from 'react';
import {    
    Box,
    Collapse,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    TextField,
    Tooltip,
    Typography,
    withWidth
   
} from '@material-ui/core';
import {    Autocomplete    } from '@material-ui/lab';
import { 
    Block as BlockIcon,
    Check as CheckIcon,
    CheckCircle as CheckCircleIcon,
    Delete as DeleteIcon,
    Edit as EditIcon,
    KeyboardArrowUp as KeyboardArrowUpIcon,
    KeyboardArrowDown as KeyboardArrowDownIcon,
    Search as SearchIcon,
} from '@material-ui/icons';
import { blue, teal, pink, indigo } from '@material-ui/core/colors';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import { useAuth } from "../Auth";
import Swal from 'sweetalert2';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { 
    Modal as ModalAntd,
} from 'antd';

const columns = [
    { id: 'Servicios', label: 'Servicios', minWidth: 170,numeric: false, disablePadding: false },
    { id: 'Nombres', label: 'Nombres', minWidth: 170,numeric: false, disablePadding: false },
    { id: 'CI', label: 'CI', minWidth: 100, numeric: false, disablePadding: false },
    { id: 'Registro', label: 'Registro', minWidth: 170, align: 'right', numeric: false, disablePadding: false}, 
    { id: 'celular', label: 'Celular', minWidth: 170, align: 'right', numeric: false, disablePadding: false}, 
    { id: 'correo', label: 'Correo', minWidth: 170, align: 'right', numeric: false, disablePadding: false}, 
    { id: 'Status', label: 'Status', minWidth: 170, align: 'right', numeric: true, disablePadding: false}, 
];

const styles = makeStyles((theme)=>({
    paper:{
        padding:20
    },
    button:{
        color:'#fff'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    container: {
        minHeight:'70vh',
        height:650,
        maxHeight: '70vh',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    paperHead:{
        height:50,
        padding:6
    }
}));

const Roow = memo(({authTokens, handleDelete, rowInfo, zonaSelectedObject, handleUpdate})=>{
    const [ openCollapse, setOpenCollapse] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [ openCambioCI, setOpenCambioCI ] = useState(false);
    const [ openCambioNombres, setOpenCambioNombres ] = useState(false);
    const [ getCI, setCI ] = useState('');
    const [ getNombres, setNombres ] = useState('');
    const [ isChanging, setChanging ] = useState(false);

    const handleCollapse = ()=>{setOpenCollapse(!openCollapse);}; 

    const handleSubDelete = ()=>{
        fetch('/api/clientes/',{
            method:'DELETE',
            body: JSON.stringify(rowInfo),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                handleDelete(rowInfo);
                Swal.fire({
                    title: 'CLIENTE ELIMINADO',
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596'
                  })         
            }else{
                if(result.status === 'no such item (4)'){
                    Swal.fire({
                        title: 'SIN ACCESO MIKROTIK',
                        text:'DESEA ELIMINAR A ESTE CLIENTE DE TODAS LAS BASES DE DATOS PERO NO DEL MIKROTIK',
                        showDenyButton: true,
                        showCancelButton: false,
                        confirmButtonColor:'#005596'
                        }).then((result) => {
                        if (result.isConfirmed) {
                            fetch('/api/clientesNoMikrotik',{
                                method:'DELETE',
                                body: JSON.stringify(rowInfo),
                                headers:{
                                    'Content-Type': 'application/json'
                                }
                            }) 
                            .then(response=> response.json())
                            .then(result =>{
                                if(result.message){
                                    Swal.fire({
                                        title: 'CLIENTE ELIMINADO',
                                        icon:'success',
                                        showDenyButton: false,
                                        showCancelButton: false,
                                        confirmButtonColor:'#005596'
                                    }) 
                                    handleDelete(rowInfo);
                                }else{
                                    Swal.fire({
                                        title: 'ERROR',
                                        icon:'error',
                                        showDenyButton: false,
                                        showCancelButton: false,
                                        confirmButtonColor:'#005596'
                                    }) 
                                }
                                
                            })
                        }
                    })
                }else{
                    enqueueSnackbar(result.status, {variant:'error'});
                }
                
            }
        });
    };

    const handleDeleteClient = ()=>{
        if(authTokens.Type === 'ADMINISTRADOR'){
            Swal.fire({
                title: 'DESEA ELIMINAR ESTE CLIENTE?',
                text:'SE ELIMINARA A ESTE CLIENTE DE TODAS LAS BASES DE DATOS',
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonColor:'#005596'
                }).then((result) => {
                if (result.isConfirmed) {
                    handleSubDelete();
                }
            });
        }else{
            alert('NO TIENE LOS PERMISOS NECESARIOS PARA ELIMINAR');
        }
    };

    const handleSuspender = ()=>{
        Swal.fire({
            title:rowInfo.Status === 'Activo' ? 'Desea Suspender a Este Cliente?': 'Desea Activar a Este Cliente?',
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonColor:indigo[900],
            confirmButtonText:'Proceder',
            cancelButtonText:'Cancelar',
            width:580
        }).then(response=>{
            if(response.isConfirmed){
                fetch('/api/clientes/suspender',{
                    method:'POST',
                    body: JSON.stringify({Nombres:rowInfo.Nombres, Status:rowInfo.Status === 'Activo' ? 'Suspendido' : 'Activo'}),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    if(result.message){ 
                        Swal.fire({
                            title: rowInfo.Status === 'Activo' ? 'Cliente Suspendido' : 'Cliente Activado',
                            icon:'success',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:indigo[900],
                            confirmButtonText:'Listo'
                        })
                        const objeto = {...rowInfo};
                        objeto.Status =  rowInfo.Status === 'Activo' ? 'Suspendido' : 'Activo';
                        handleUpdate(objeto);
                    }else{
                        enqueueSnackbar(result.status,{variant:'error'});
                    }
                });
                
            }
        })
    };

    const handleSuspenderServicio = (idServicio, StatusServ)=>{
        Swal.fire({
            title:StatusServ === 'Activo' ? 'Desea Suspender a Este Servicio?': 'Desea Activar a Este Servicio?',
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonColor:indigo[900],
            confirmButtonText:'Proceder',
            cancelButtonText:'Cancelar',
            width:580
        }).then(response=>{
            if(response.isConfirmed){
                fetch('/api/servicios/suspender',{
                    method:'POST',
                    body: JSON.stringify({Nombres:rowInfo.Nombres, idServicio, Status:StatusServ === 'Activo' ? 'Suspendido' : 'Activo'}),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    if(result.message){ 
                        Swal.fire({
                            title: StatusServ === 'Activo' ? 'Servicio Suspendido' : 'Cliente Activado',
                            icon:'success',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:indigo[900],
                            confirmButtonText:'Listo'
                        })
                        const objeto = {...rowInfo};
                        const ServiciosMap = rowInfo.Servicios.map(el=>{
                            if(el._id === idServicio){
                                const objeto2 = {...el};
                                objeto2.Status = StatusServ === 'Activo' ? 'Suspendido' : 'Activo';
                                return objeto2;
                            }else{
                                return el;
                            }
                        })
                        objeto.Servicios = ServiciosMap;
                        handleUpdate(objeto);
                    }else{
                        enqueueSnackbar(result.status,{variant:'error'});
                    }
                });
                
            }
        })
    };

    const handleCambioCI = ()=>{
        setChanging(true);
        if(getCI.length < 9){
            enqueueSnackbar('CI INCORRECTA', {variant:'error'});
            setChanging(false);
        }else{
            const objeto = {...rowInfo};
            objeto.InfoZona = zonaSelectedObject;
            objeto.CINew = getCI;
            objeto.isName = false;
            fetch('/api/clientes',{
                method:'PUT',
                body: JSON.stringify(objeto),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(result =>{
                setChanging(false);
                if(result.message){
                    const objeto2 = {...rowInfo};
                    objeto2.CI = getCI;
                    handleUpdate(objeto2);
                    enqueueSnackbar('CLIENTE EDITADO', { variant:'success'}); 
                    setOpenCambioCI(false);
                    setCI('');   
                }else{
                    enqueueSnackbar(result.status, {variant:'error'});
                }
            });
        }
    };

    const handleCambioNombres = ()=>{
        setChanging(true);
        const objeto = {...rowInfo};
        objeto.InfoZona = zonaSelectedObject;
        objeto.NombreNew = getNombres;
        objeto.isName = true;
        fetch('/api/clientes',{
            method:'PUT',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            setChanging(false);
            if(result.message){
                const objeto2 = {...rowInfo};
                objeto2.Nombres = getNombres;
                handleUpdate(objeto2);
                enqueueSnackbar('CLIENTE EDITADO', { variant:'success'});  
                setOpenCambioNombres(false);
                setNombres('');  
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
            }
        });
    };

    const handleCloseCI = ()=>{
        setOpenCambioCI(false);
        setCI('');
    };

    const handleCloseNombres = ()=>{
        setOpenCambioNombres(false);
        setNombres('');
    };
    
    return(
        <React.Fragment key={rowInfo.Nombres}>
            <ModalAntd 
                title="CAMBIO DE CI" 
                visible={openCambioCI} 
                onCancel={handleCloseCI} 
                onOk={handleCambioCI} 
                okText='PROCEDER'
                cancelText='RETROCEDER'
                bodyStyle={{display:'flex', justifyContent:'center'}}
                okButtonProps={{ disabled:isChanging, loading:isChanging }}
                destroyOnClose
                >
                    <TextField
                        autoFocus
                        label='CI'
                        fullWidth
                        onChange={({target})=>{setCI(target.value.trim());}}
                        value={getCI || ''}
                        size='small'
                        variant='outlined'                                    
                    />
                
            </ModalAntd> 
            <ModalAntd 
                title="CAMBIO DE NOMBRES" 
                visible={openCambioNombres} 
                onCancel={handleCloseNombres} 
                onOk={handleCambioNombres} 
                okText='PROCEDER'
                cancelText='RETROCEDER'
                bodyStyle={{display:'flex', justifyContent:'center'}}
                okButtonProps={{ disabled:isChanging, loading:isChanging }}
                destroyOnClose
                >
                    <TextField
                        autoFocus
                        label='NOMBRES'
                        fullWidth
                        onChange={({target})=>{setNombres(target.value.toUpperCase());}}
                        value={getNombres || ''}
                        size='small'
                        variant='outlined'       
                        placeholder='Empiece con los Apellidos'                             
                    />
                
            </ModalAntd> 
            <TableRow hover style={{backgroundColor:rowInfo.Status === 'Suspendido' ? pink.A400: '#ffffff'}}>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={handleCollapse}>
                        {openCollapse ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                    <Tooltip arrow title='Editar Nombre' placement='top'>
                        <span>
                            <IconButton aria-label="expand row" size="small" onClick={()=>{ setOpenCambioNombres(true)}}>
                                <EditIcon style={{color:rowInfo.Status === 'Activo' ? 'green' : '#fff'}}/>
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip arrow title='Editar CI' placement='top'>
                        <span>
                            <IconButton aria-label="expand row" size="small" onClick={()=>{ setOpenCambioCI(true)}}>
                                <EditIcon style={{color:rowInfo.Status === 'Activo' ? 'orange' : '#fff'}}/>
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip arrow title={rowInfo.Status === 'Activo' ? 'Suspender Cliente' : 'Activar Cliente'} placement='top'>
                        <span>
                            <IconButton aria-label="expand row" size="small" onClick={handleSuspender} >
                                {
                                    rowInfo.Status === 'Activo' ? <BlockIcon style={{color:'dodgerblue'}}/> :
                                    <CheckIcon style={{color:rowInfo.Status === 'Activo' ? 'dodgerblue' : '#fff'}}/>
                                }
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip arrow title='Eliminar' placement='right'>
                        <span>
                            <IconButton aria-label="expand row" size="small" onClick={handleDeleteClient}>
                                <DeleteIcon style={{color:rowInfo.Status === 'Activo' ? 'red' : '#fff'}}/>
                            </IconButton>
                        </span>
                    </Tooltip>
                    
                </TableCell>
                <TableCell>
                    {rowInfo.Nombres}
                </TableCell>
                <TableCell>
                    {rowInfo.CI}
                </TableCell>
                <TableCell>
                    {rowInfo.Registro}
                </TableCell>
                <TableCell>
                    {rowInfo.Celular[0].celular}
                </TableCell>
                <TableCell>
                    {rowInfo.Correo[0].correo}
                </TableCell>
                <TableCell style={{color:rowInfo.Status === 'Suspendido' ? '#ffffff':teal[600], fontWeight:'bolder'}}>
                    {rowInfo.Status}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={openCollapse} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                        <Typography variant="h6" gutterBottom component="div">
                            Servicios
                        </Typography>
                        <Table size="small" aria-label="purchases">
                            <TableHead>
                            <TableRow>
                                <TableCell style={{background:teal[400], color:'#fff'}} >Action</TableCell>
                                <TableCell style={{background:teal[400], color:'#fff'}} >Tipo Servicio</TableCell>
                                <TableCell style={{background:teal[400], color:'#fff'}} >Plan</TableCell>
                                <TableCell style={{background:teal[400], color:'#fff'}} >Direccion</TableCell>
                                <TableCell style={{background:teal[400], color:'#fff'}} >Address Ip</TableCell>
                                <TableCell style={{background:teal[400], color:'#fff'}} >Instalacion</TableCell>
                                <TableCell style={{background:teal[400], color:'#fff'}} >Registro</TableCell>
                                <TableCell style={{background:teal[400], color:'#fff'}} >Status</TableCell>
                                <TableCell style={{background:teal[400], color:'#fff'}} >Zona</TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {rowInfo.Servicios.map((historyRow, index) => (
                                <TableRow key={`subRow-${rowInfo.Mes}-${index}`}>
                                    <TableCell component="th" scope="row">
                                        {
                                            historyRow.Status === 'Activo'?
                                            <Tooltip placement='top' title='Suspender Servicio'>
                                                <IconButton size='small' color='primary' onClick={()=>{handleSuspenderServicio(historyRow._id, historyRow.Status)}}>
                                                    <BlockIcon style={{color:'red'}}/>
                                                </IconButton>
                                            </Tooltip>:
                                            <Tooltip placement='top' title='Activar Servicio'>
                                                <IconButton size='small' color='primary' onClick={()=>{handleSuspenderServicio(historyRow._id, historyRow.Status)}}>
                                                    <CheckCircleIcon style={{color:'green'}}/>
                                                </IconButton>
                                            </Tooltip>
                                        }
                                        
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {historyRow.TipoServicio}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {historyRow.Plan}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {historyRow.Direccion}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {historyRow.AddressIp}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {historyRow.Instalacion}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {historyRow.Registro}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {historyRow.Status}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {historyRow.ZonaService}
                                    </TableCell>
                                    </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
});

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
};
  
function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSorthandler = (property) => (event) => {
      onRequestSort(event, property);
    };
  
    return (
      <TableHead >
        <TableRow >
          {columns.map((headCell) => (
            <TableCell
              key={headCell.id}
              align='left'
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
              style={{background:blue[600], color:'#fff'}}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSorthandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
};

const ClientList = ({widthWin})=>{
    const { authTokens } = useAuth(); 
    const [ data, setData]= useState([]);
    const [ dataBackup, setDataBackup]= useState([]);
    const [ order, setOrder] = useState('asc');
    const [ orderBy, setOrderBy] = useState('Nombres');
    const classes = styles();
    const [ page, setPage] = useState(0);
    const [ rowsPerPage, setRowsPerPage] = useState(12);
    const [ userName, setUserName ] = useState('');
    //const [ idMikrotik, setIdMikrotik] = useState('');
    const [ dataZona, setDataZona ] = useState([]);
    const [ zonaSelected, setZonaSelected ] = useState('');
    const [ valFil, setValFil ] = useState('');
    const [ zonaSelectedObject, setZonaSelectedObject ] = useState({});
    const [ isSelectZone, setSelectZone ] = useState(false);
    const [ getId, setId ] = useState('');
    const [ rowChange, setRowChange ] = useState({});
    const [ isContinuo, setContinuo ] = useState(false);

    useEffect(
        ()=>{
            async function ReqInfo() {
                const dataZonas = await fetch('/api/zonas');
                const resultZona = await dataZonas.json();
                const dataCli = await fetch('/api/clientes'); 
                const resultCli = await dataCli.json();
                if(authTokens.Type === 'ADMINISTRADOR'){
                    setDataZona(resultZona); 
                    setData(resultCli.filter(el=> el.Empresa === authTokens.Empresa));
                    setDataBackup(resultCli.filter(el=> el.Empresa === authTokens.Empresa));
                }else{
                    const ZonasArr = authTokens.Zonas.map(valZon=> valZon.Zona);
                    const arrFilZ = resultZona.filter(arrZ => ZonasArr.includes(arrZ.Zona.toString()));
                    setDataZona(arrFilZ);
                    const arrFil = resultCli.filter(value=> ZonasArr.includes(value.Zona.toString()))
                    const arr = [];
                    arrFil.forEach((value,index)=>{
                        const objeto = {...value};
                        objeto.correo = value.Correo[0].correo;
                        objeto.celular = value.Celular[0].celular;
                        objeto.convencional = value.Convencional[0].convencional;
                        objeto.Zona = value.Zona;
                        arr.push(objeto);
                        if(index === (arrFil.length - 1)){
                            setData(arr.filter(el=> el.Empresa === authTokens.Empresa));
                            setDataBackup(arr.filter(el=> el.Empresa === authTokens.Empresa));
                        }
                    });
                }
            };
            ReqInfo();
        },[] // eslint-disable-line react-hooks/exhaustive-deps
    );

    useEffect(()=>{
        if(isContinuo){
            setContinuo(false);
            handleContinuoEdit();
        }
    },[isContinuo]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {setPage(newPage);};
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDelete = useCallback((rowInfo)=>{
        const arrBackup  = [...dataBackup];
        const arr = arrBackup.filter(element=> element._id !== rowInfo._id);
        setDataBackup(arr);
        setUserName('');
        setValFil('');
        if(isSelectZone){ 
            const arrFil =  arr.filter(value=> value.Zona.toString() === zonaSelected.toString());
            setData(arrFil) 
        }else{ 
            setData(arr) 
        }
    },[dataBackup, isSelectZone, zonaSelected]);

    const handleUpdate = useCallback((rowInfo)=>{
        setRowChange(rowInfo);
        setData([]);
        setContinuo(true);
    },[]);

    const handleContinuoEdit = ()=>{
        const arrBackup_0  = [...dataBackup];
        const arr_0 = arrBackup_0.map(el=> ( el._id.toString() === rowChange._id.toString() ? rowChange : el));
        setDataBackup(arr_0.sort(function(a, b){return a.Nombres - b.Nombres}));
        setUserName('');
        setValFil('');
        setId('');
        setRowChange({});
        if(isSelectZone){ 
            const arrFil_0 = arr_0.filter(value=> value.Zona.toString() === zonaSelected.toString());
            setData(arrFil_0.sort(function(a, b){return a.Nombres - b.Nombres}));
        }else{ 
            setData(arr_0.sort(function(a, b){return a.Nombres - b.Nombres}));
        }
    };

    const handleSelectName = (value)=>{
        setUserName(value);
        const arr = data.filter(value2=> value2.Nombres === value);
        setData(arr);
    };

    const handleClear = ()=>{
        setUserName('');
        setData(dataBackup);
        setId('');
    };

    const handleSelectZona = (valZ)=>{
        setZonaSelected(valZ);
        const objetoZona = dataZona.filter(elZona=> elZona.Zona.toString() === valZ.toString())[0];
        const arrFil =  dataBackup.filter(value=> value.Zona.toString() === valZ.toString());
        setData(arrFil);
        setZonaSelectedObject(objetoZona);
        setSelectZone(true);
        setId('');
    };

    const handleClearZona = ()=>{
        setData(dataBackup);
        setZonaSelected('');
        setZonaSelectedObject({});
        setUserName('');
        setValFil('');
        setSelectZone(false);
        setId('');
    };

    const handleFilterEl = (valFilter)=>{
        const arr = dataBackup.filter(value=> value.CI.toString().toUpperCase() === valFilter.toString().toUpperCase());
        setValFil(valFilter);
        setData(arr);
    };

    const handleFilterReset = ()=>{ setData(dataBackup);setId(''); };

    const handleSearchbyId = ()=>{
        const arrTot = [];
        const backup = [...dataBackup];
        for(const x in backup){
            const objeto = {...backup[x]};
            for(const y in objeto.Servicios){
                if(objeto.Servicios[y].idForMikrotik.toString().toUpperCase().trim() === getId.toString().trim().toUpperCase())arrTot.push(objeto)
            }
        };
        setData(arrTot);
    };

    const handleBlurId = ({target})=>{
        const backup = [...dataBackup];
        if(target.value === ''){
            setData(backup)
        }else{
            const arrTot = [];
            const backup = [...dataBackup];
            for(const x in backup){
                const objeto = {...backup[x]};
                for(const y in objeto.Servicios){
                    if(objeto.Servicios[y].idForMikrotik.toString().toUpperCase().trim() === getId.toString().trim().toUpperCase())arrTot.push(objeto)
                }
            };
            setData(arrTot);
        }
    };


    return(
        <Grid container justifyContent='center' style={{padding:10, height:'92vh'}}>
            <Paper elevation={2} style={{width:'100%', height:'91vh'}}>
            <Grid container justifyContent='center'>
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <Paper style={{minHeight:60, padding:5}} >
                        <Grid container spacing={1} style={{paddingTop:5}}>
                            <Grid item xl={3} lg={3} md={3} sm={4} xs={12}>
                                <Autocomplete
                                    id="Zona"
                                    options={dataZona.map(value=>value.Zona)}
                                    value={zonaSelected || ''}                              
                                    renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={(e,value, reason)=>{
                                        if(reason ===  'clear'){
                                            handleClearZona()
                                        }else{
                                            handleSelectZona(value);
                                        }
                                    }}  
                                />
                            </Grid>
                            <Grid item xl={3} lg={3} md={3} sm={4} xs={6} >
                                <TextField 
                                    id='ID'
                                    fullWidth
                                    label='ID'
                                    value={getId || ''}
                                    onChange={({target})=>{setId(target.value)}}
                                    InputProps={{
                                        endAdornment: 
                                        <IconButton aria-label="search" onClick={handleSearchbyId}   size='small'>
                                            <SearchIcon color='primary' />
                                        </IconButton>
                                    }}
                                    variant='outlined'
                                    size='small'
                                    onBlur={handleBlurId}
                                />
                            </Grid>
                            <Grid item xl={3} lg={3} md={3} sm={4} xs={6} >
                                <Autocomplete
                                    id="Nombres"
                                    options={data.map(value=>value.Nombres)}
                                    value={userName || ''}                              
                                    renderInput={(params) => <TextField {...params} variant="outlined" size='small' fullWidth placeholder='Filtrado Nombres' />}
                                    onChange={(e,value, reason)=>{
                                        if(reason ===  'clear'){
                                            handleClear()
                                        }else{
                                            handleSelectName(value);
                                        }
                                    }}  
                                />
                            </Grid>
                            {
                                widthWin === 'xl' || widthWin === 'lg' || widthWin === 'md' ?
                                <Grid item xl={3} lg={3} md={3} sm={4} xs={4} >
                                    <Autocomplete
                                        id="FiltradoEl"
                                        options={data.map(value=>value.CI)}
                                        value={valFil || ''}                              
                                        renderInput={(params) => <TextField {...params} variant="outlined" size='small' fullWidth placeholder='Filtrado CI' />}
                                        onChange={(e,value, reason)=>{
                                            if(reason ===  'clear'){
                                                handleFilterReset()
                                            }else{
                                                handleFilterEl(value);
                                            }
                                        }}  
                                    />
                                </Grid>:null
                            }
                            
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <Grid container justifyContent='center' style={{minHeight:'75vh',  maxHeight:'75vh',}}>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <TableContainer className={classes.container}>
                                <Scrollbars
                                    autoHide
                                    autoHideTimeout={1000}
                                    autoHideDuration={200}
                                >
                                <Table stickyHeader aria-label="sticky table" size='small'>
                                <EnhancedTableHead
                                    classes={classes}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={data.length}
                                    />
                                <TableBody>
                                {stableSort(data, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    return (
                                        <Roow 
                                            authTokens={authTokens}
                                            handleDelete={handleDelete} 
                                            handleUpdate={handleUpdate}
                                            key={`${row.id}-${index}`} 
                                            rowInfo={row} 
                                            zonaSelectedObject={zonaSelectedObject} 
                                        />
                                    );
                                    })}
                                    
                                </TableBody>
                                </Table>
                                </Scrollbars>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={data.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage='Filas'

                            />
                        </Grid>
                        
                    </Grid>
                </Grid>
            </Grid>
            </Paper>
        </Grid>
        
    )

};

const Cliente_Listado= (props)=>{
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
          <ClientList widthWin={props.width}/>
        </SnackbarProvider>
    );
};

export default withWidth()(Cliente_Listado);